/* eslint-disable */
import { Avatar } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import { ORDER_STATUS_NEW } from '../../Constants/Order/Order.constants';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import Icons from '../Icons/Icons.component';
import OrderStatusPropTypes from './OrderStatus.component.props';
import OrderStatusStyles from './OrderStatus.component.styles';

/**
 * getOrderStatusChipClasses
 * @param {number} orderStatus order status
 * @param {Object} classes classes
 * @returns {React.Component} component
 */
const getOrderStatusChipClasses = (orderStatus, classes) => ({
  colorPrimary: classes[orderStatus],
  root: classes.root,
});

/**
 * OrderStatusComponent
 * @param {Object} props props
 * @returns {React.Component} component
 */
export const OrderStatusComponent = (props) => {
  const { status, classes } = props;

  const chipClassName = getOrderStatusChipClasses(status, classes);

  return status === ORDER_STATUS_NEW ? (
    <Chip
      classes={{ root: classes.chipNew }}
      variant="outlined"
      color="primary"
      avatar={
        <Avatar className={classes.avatar}>
          <Icons type="DOUBLE_ARROW" />
        </Avatar>
      }
      label={
        <I18n data={{ orderStatus: status }} textTransform="none">
          OrderService.Status
        </I18n>
      }
    />
  ) : (
    <Chip
      classes={chipClassName}
      color="primary"
      label={
        <I18n data={{ orderStatus: status }} textTransform="none">
          OrderService.Status
        </I18n>
      }
    />
  );
};
OrderStatusComponent.displayName = `OrderStatus`;
OrderStatusComponent.propTypes = OrderStatusPropTypes;

/** @type {React.ComponentClass<OrderStatusComponentProps>} */
const OrderStatus = compose(withStyles(themeCreateInjectableStyles(OrderStatusStyles), { withTheme: true }))(OrderStatusComponent);

export default OrderStatus;
